import { render, staticRenderFns } from "./PerformanceMetricsIcon.vue?vue&type=template&id=653a9a02&scoped=true"
import script from "./PerformanceMetricsIcon.vue?vue&type=script&lang=js"
export * from "./PerformanceMetricsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653a9a02",
  null
  
)

export default component.exports